<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Основные документы') }}
            </v-toolbar-title>
          </v-toolbar>
          <general-error v-if="!!generalError" />
          <v-card-text>
            <v-expansion-panels multiple>
              <v-expansion-panel
                  v-for="(item,i) in items"
                  :key="i">
                <v-expansion-panel-header>
                  <div>
                    <v-icon>
                      view_list
                    </v-icon> {{ $t(item.header) }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <!-- <v-row
                      v-for="(doc, j) in item.docs"
                      :key="j"
                      mb-2
                      ml-4>
                    <v-col>
                      <a :href="doc.url" target="_blank">
                        {{ doc.text }}
                      </a>
                    </v-col>
                  </v-row> -->
                  <static-page :key="item.tag" :page-tag="item.tag" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import StaticPage from '@/components/reused/staticPages/StaticPage.vue'
  import { STATIC_PAGES_TAGS /*, DOCUMENT_TYPES */ } from '@/constants/business'

  export default {
    components: {
      GeneralError,
      StaticPage
    },
    data () {
      return {
        items: [
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_TARIFFS,
            header: this.$t('Регламент и тарифы'),
            docs: [
              // { url: this.getDocumentLink('reglament'), text: this.$t('Регламент проведения торгов в Системе электронных торгов внебиржевого рынка (сегмент Экспорт)') },
            ]
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_ORG_REGISTRATION,
            header: this.$t('Шаблоны документов, необходимых для регистрации организации'),
            docs: [
              // { url: this.getDocumentLink(DOCUMENT_TYPES.ORGANIZATION_AUTHORIZATION_DOCUMENT), text: this.$t('Доверенность на регистрацию Пользователя ') },
            ]
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_USER_REGISTRATION,
            header: this.$t('Шаблоны документов, необходимых для регистрации Уполномоченных представителей'),
            docs: [

            ]
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_GUIDES,
            header: this.$t('Руководства для регистрации и работы на электронной площадке'),
            docs: [
              { url: this.getDocumentLink('registrationGuide'), text: this.$t('Руководство по регистрации в {0}', ['в системе']) },
              { url: this.getDocumentLink('restoreAccessToAccountGuide'), text: this.$t('Руководство по восстановлению доступа к личному кабинету') },
              { url: this.getDocumentLink('withdrawalGuide'), text: this.$t('Руководство по выводу денежных средств') },
              { url: this.getDocumentLink('tradeNotificationLotDocumentation'), text: this.$t('Шаблон "Извещения о проведении торгов"') }
            ]
          }
          // {
          //   tag: STATIC_PAGES_TAGS.STATIC_DOCS_REQUISITES,
          //   header: this.$t('Реквизиты счетов'),
          //   docs: [
          //     { url: this.getDocumentLink('requisitesForPayment'), text: this.$t('Реквизиты для оплаты и назначение платежей') }
          //   ]
          // }
        ]
      }
    },
    methods: {
      getDocumentLink (docType) {
        return this.getSystemFileUrl(Vue.getDocumentTemplateInfo(docType).path)
      }
    }
  }
</script>
